/* eslint-disable no-unused-vars */
import { defineAbility } from '@casl/ability';
import { USER_ROLES } from '../../utils/const';
// import { initialAbility } from './initialAbility'

const COUNTRY = process.env.REACT_APP_COUNTRY;

// Careers permissions
const Careers = {
  key: 'CAREERS',
  permissions: {
    view: 'view',
    edit: 'edit',
  },
};

// Dashboard permissions
const Dashboard = {
  key: 'DASHBOARD',
  permissions: {
    view: 'view',
  },
};

// Properties permissions
const Properties = {
  key: 'PROPERTIED',
  permissions: {
    view: 'view',
    update: 'update',
  },
};

// Docusign Permissions
const Docusign = {
  key: 'DOCUSIGN',
  permissions: {
    view: 'view',
  },
};

// Transactions Permissions
const Transactions = {
  key: 'TRANSACTIONS',
  permissions: {
    view: 'view',
    cancel: 'cancel',
    markPaid: 'markPaid',
  },
};

const EMDAssessment = {
  key: 'EMD_ASSESSMENT',
  permissions: {
    view: 'view',
    update: 'update',
  },
};

const SMSCampaign = {
  key: 'SMS_CAMPAIGN',
  permissions: {
    view: 'view',
    update: 'update',
  },
};

const PropertyUpdates = {
  key: 'PROPERTY_UPDATES',
  permissions: {
    view: 'view',
    update: 'update',
  },
};

const UsersDashboard = {
  key: 'USERS_DASHBOARD',
  permissions: {
    view: 'view',
    viewProfile: 'viewProfile',
  },
};

const EmdDashboardIdDocuments = {
  key: 'EMD_DASHBOARD_ID_DOCUMENTS',
  permissions: {
    view: 'view',
  },
};

const NonIdSensitiveInformationForEmdDashboard = {
  key: 'EMD_DASHBOARD_SENSITIVE',
  permissions: {
    view: 'view',
  },
};

// Export all Abilities
export const Abilities = {
  Dashboard,
  Docusign,
  Transactions,
  EMDAssessment,
  SMSCampaign,
  PropertyUpdates,
  Properties,
  UsersDashboard,
  Careers,
  EmdDashboardIdDocuments,
  NonIdSensitiveInformationForEmdDashboard,
};

function getAdminPermissions(can, cannot) {
  can(Dashboard.permissions.view, Dashboard.key);

  can(Docusign.permissions.view, Docusign.key);

  can(Transactions.permissions.view, Transactions.key);
  can(Transactions.permissions.cancel, Transactions.key);
  can(Transactions.permissions.markPaid, Transactions.key);

  can(EMDAssessment.permissions.view, EMDAssessment.key);
  can(EMDAssessment.permissions.update, EMDAssessment.key);

  can(SMSCampaign.permissions.view, SMSCampaign.key);

  can(PropertyUpdates.permissions.view, PropertyUpdates.key);

  can(Properties.permissions.view, Properties.key);
  can(Properties.permissions.update, Properties.key);
  can(UsersDashboard.permissions.view, UsersDashboard.key);
  can(UsersDashboard.permissions.viewProfile, UsersDashboard.key);
  if (COUNTRY === 'CA') {
    can(Careers.permissions.view, Careers.key);
    can(Careers.permissions.edit, Careers.key);
  }
  can(
    NonIdSensitiveInformationForEmdDashboard.permissions.view,
    NonIdSensitiveInformationForEmdDashboard.key
  );
}

function getIssuerPermissions(can, cannot) {
  // can(Dashboard.permissions.view, Dashboard.key);

  // can(Docusign.permissions.view, Docusign.key);

  can(Transactions.permissions.view, Transactions.key);
  can(Transactions.permissions.cancel, Transactions.key);
  can(Transactions.permissions.markPaid, Transactions.key);

  // can(EMDAssessment.permissions.view, EMDAssessment.key);
  // can(EMDAssessment.permissions.update, EMDAssessment.key);

  // can(SMSCampaign.permissions.view, SMSCampaign.key);

  // can(PropertyUpdates.permissions.view, PropertyUpdates.key);

  // can(Properties.permissions.view, Properties.key);
  // can(Properties.permissions.update, Properties.key);
  // can(UsersDashboard.permissions.view, UsersDashboard.key);
  // can(UsersDashboard.permissions.viewProfile, UsersDashboard.key);
}

function getEMDPermissions(can, cannot) {
  can(EMDAssessment.permissions.view, EMDAssessment.key);
  can(EMDAssessment.permissions.update, EMDAssessment.key);
  can(EmdDashboardIdDocuments.permissions.view, EmdDashboardIdDocuments.key);
  can(
    NonIdSensitiveInformationForEmdDashboard.permissions.view,
    NonIdSensitiveInformationForEmdDashboard.key
  );
}

function getMarketingPermissions(can, cannot) {
  // can(Docusign.permissions.view, Docusign.key);
  // can(PropertyUpdates.permissions.view, PropertyUpdates.key);
  // can(Properties.permissions.view, Properties.key);
  // can(SMSCampaign.permissions.view, SMSCampaign.key);
  can(Transactions.permissions.view, Transactions.key);
  can(UsersDashboard.permissions.view, UsersDashboard.key);
  can(Careers.permissions.view, Careers.key);
  can(Careers.permissions.edit, Careers.key);
}

function getSponsorPermissons(can, cannot) {
  can(EMDAssessment.permissions.view, EMDAssessment.key);
}
export default function defineAbilityFor(user = null) {
  return defineAbility((can, cannot) => {
    if (user) {
      const { user_role = 5 } = user;
      switch (user_role) {
        case USER_ROLES.BP_ADMIN:
          getAdminPermissions(can, cannot);
          break;
        case USER_ROLES.EMD_PARTNER:
          getEMDPermissions(can, cannot);
          break;
        case USER_ROLES.BP_MARKETING_USER:
          getMarketingPermissions(can, cannot);
          break;
        case USER_ROLES.ISSUER:
          getIssuerPermissions(can, cannot);
          break;
        case USER_ROLES.SPONSOR:
          getSponsorPermissons(can, cannot);
          break;
        default:
          break;
      }
    }
  });
}
